const images = {
  logo1: require("./Imagenrecortada.png"),
  logo2: require("./logBeneficios2.webp"),
  logo3: require("./Animation.json"),
  logo4: require("./Recogemos tu inventario.png"),
  logo5: require("./integracionesimg.jpeg"),
  logo5_1: require("./integracionesimg2.png"),
  logo6: require("./Almacentamiento.json"),
  logo7: require("./ImagenContacto.png"),
  logo8: require("./Quienes-somos.webp"),
  logo9: require("./DeliveryAnimation.json"),
  InovacionSection: require("./inovationSection.png"),
  RetailerSection: require("./retailerslideresSection.png"),
  RespaldoSection: require("./respaldoSection.png"),
  RespaldoAnimation: require("./AnimacionRespaldo.json"),
  ImagenAlmacentamiento: require("./ImagenAlmacentamiento.jpg"),
  ShipplyPNG: require("./Shipply-SinFondo.webp"),
  ShipplyBox: require("./shipply-box-transparent.png"),
  EnviosImg: require("./EnviosImg.png"),
  AnimationAnalytics: require("./AnimationAnalytics.json"),
  AnimationAlmacentamient: require("./Animation-Almacenamiento.json"),
  //Servicios
  Personalizacion: require("./Personalizacion.jpeg"),
  Maquila: require("./MaquilaEmbalaje.jpeg"),
  Control: require("./ControlCalidad.jpeg"),
  GestionDevolucion: require("./GestionDevoluciones.jpeg"),
  Etiquetado: require("./Etiquetado.jpeg"),

  //Logistics Section
  LogisticSection: require("./LogisticSection.png"),
  //Fotos Blog
  GuiasPracticas: require("./Guiaspracticas.jpg.webp"),
  AnalisisNoticias: require("./NoticiasRecientes.png"),
  ComparativaServicios: require("./ComparativaServicios.jpg.webp"),
  LogisticaUrbana: require("./LogisticaUrbana.avif"),
  AutomatizacionAlmacenes: require("./Automatizacion.avif"),
  InventoryControlPage: require("./Inventory.png"),

  // Logos empresas
  cargalibre: require("./LOGO CARGALIBRE.png"),
  // proimpo: require('./Proimpo.png'),
  scribe: require("./ScribeLogo.png"),
  casaLuker: require("./CasaLuker.png"),
  maestriEmocional: require("./Maestria-emocionalLogo.png"),
  travelBlue: require("./Travel-Blue.png"),
  dia11: require("./diaonce.webp"),
  alohaBaby: require("./alohaBaby.png"),
  cacaoHunter: require("./cacao-hunters-logo.png"),
  // anasac: require('./anasac.png'),
  santaAnita: require("./SantaAnita.png.webp"),
  avplasticsTrade: require("./avplastics.jpeg"),
  // Logos empresas integraciones
  shopify: require("./shopify.png"),
  vtex: require("./vtex.png"),
  mercadoLibre: require("./mercadoLibre.png"),
  magento: require("./magento.png"),
  woocomerce: require("./woocomerce.png"),
  rappi: require("./rappi.png"),
  linio: require("./linio.png"),
};

export default images;
